/**
 * 普通分页
 * @type {string}
 */
export const PAGE_CONFIG_TYPE_PAGE = 'page';
/**
 * 滚动加载
 * @type {string}
 */
export const PAGE_CONFIG_TYPE_SCROLL = 'scroll';

export default {
  props: {
    pageConfig: {
      type: Object,
      default() {
        return {
          type: PAGE_CONFIG_TYPE_PAGE, // 分页方式, page是一般分页，scroll是滚动加载
          show: true, // 是否开启分页功能
          pageSizes: [50, 100, 200, 400]
        };
      }
    }
  },
  inject: {
    $admin: {
      default: null
    }
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 50,
      total: 0
    };
  },
  methods: {
    handleSizeChange(value) {
      this.pageSize = value;
      this.$emit('size-change', value);
    },
    handlePageCurrentChange(value) {
      this.currentPage = value;
      this.$emit('page-current-change', value);
    },
    setCurrentPage(value) {
      this.currentPage = value;
    },
    getCurrentPage() {
      return this.currentPage;
    },
    setPageSize(value) {
      this.pageSize = value;
    },
    getPageSize() {
      return this.pageSize;
    },
    setTotal(value) {
      this.total = value;
    },
    getTotal() {
      return this.total;
    }
  },
  computed: {
    realPageConfig() {
      const defaultConfig = {small: false, type: PAGE_CONFIG_TYPE_PAGE, show: true, pageSizes: [50, 100, 200, 400]};
      if (this.$admin) {
        if (this.$admin.sizes !== false) {
          defaultConfig.small = this.$admin.defaultSize === 'tiny';
        }
      }
      if (!this.pageConfig) {
        return defaultConfig;
      }
      Object.assign(defaultConfig, this.pageConfig);
      return defaultConfig;
    },
    realSeqConfig() {
      if (this.realPageConfig.type === PAGE_CONFIG_TYPE_PAGE) {
        return {startIndex: (this.currentPage - 1) * this.pageSize};
      } else {
        return {startIndex: 0};
      }
    }
  },
  watch: {
    'realPageConfig.type': {
      handler(newVal) {
        if (newVal === PAGE_CONFIG_TYPE_SCROLL) {
          this.pageSize = 100;
        }
      },
      immediate: true
    }
  }
};
